import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import ServiceWorker from './ServiceWorker';

ReactDOM.render(
  <StrictMode>
    <ServiceWorker>
      <App />
    </ServiceWorker>
  </StrictMode>,
  document.getElementById('root')
);
